export class ResponseInstrumentoAtuevaluacionModel{
    payload:InstrumentoAtuevaluacionModel;

    constructor(){
        this.payload = new InstrumentoAtuevaluacionModel();
    }
}

export class InstrumentoAtuevaluacionModel{    
    idJardinPeriodo:number;
    estadoInstrumentoAutoevaluacion:number;
    dimensiones:DimensionModel[];
    estado:number;
    tipo:number;

    constructor(){
        this.idJardinPeriodo = -1;
        this.estadoInstrumentoAutoevaluacion = -1;
        this.dimensiones = new Array<DimensionModel>();
        this.estado = -1;
        this.tipo = -1;
    }
}

export class DimensionModel{    

    idDimension:number;
    orden:number; 
    dimension:string; 
    subdimensiones:SubDimensionModel[];
    constructor(){
        this.idDimension = -1;
        this.orden = -1;
        this.dimension = "";
        this.subdimensiones = new Array<SubDimensionModel>();
    }
}

export class SubDimensionModel{    
    idSubDimencion:number;
    idDimension:number;
    orden:number; 
    nombreCorto:string; 
    subDimension:string; 
    observacion:Observacion; 
    instrumentos:InstrumentosModel[];
    constructor(){
        this.idSubDimencion = -1;
        this.idDimension = -1;
        this.orden = -1;
        this.nombreCorto = "";
        this.subDimension = "";
        this.observacion = new Observacion();
        this.instrumentos = new Array<InstrumentosModel>();
    }
}


export class Observacion{    

    idObservacionSubdimencion:number;
    idSubDimencion:number;
    observacion:string;
    constructor(){
        this.idObservacionSubdimencion = -1;
        this.idSubDimencion = -1;
        this.observacion = "";
    }
}

export class InstrumentosModel{    

    idBaseInstrumentoAutoevaluacion:number;
    idSubDimencion:number;
    orden:number;
    pregunta:string;
    idRespuesta:number;
    categoriaSeleccionada:number;
    constructor(){
        this.idBaseInstrumentoAutoevaluacion = -1;
        this.idSubDimencion = -1;
        this.categoriaSeleccionada = -1;
        this.idRespuesta = -1;
        this.orden = -1;
        this.pregunta = "";
    }
}


